const message = {
  E000001: '{0},{1},「{2}」処理に失敗しました（エラー内容：{3}）',
  E000004: 'このファイル種別は使用中のため削除できません',
  E010001: '「{0}」を入力してください。',
  E010002: '「{0}」が誤っています。',
  E010003: '「{0}」の入力間違い回数の限度を超えています。時間をおいて変更してください。',
  E010004: '{0}の{1}が不正です。',
  E010005: '{0}のデータサイズは1Gバイト以上です。',
  E010006: '「{0}」は{1}文字以内で入力してください。',
  E010007: '{0}は8文字以上で半角の英大文字、英小文字、数字、記号をそれぞれ1文字含む必要があります。',
  E010008: '{0}が大きすぎます。',
  E010009: '{0}が不正です。',
  E010010: '{0}には{1}以上の数値を入力してください。',
  E010011: '{0}は{1}できません。',
  E010012: '{0}が上限を超えています。',
  E010013: '{0}は既に存在します。',
  E010014: '{0}を{1}してください。',
  E010015: '「{0}」は{1}より大きく{2}以下の範囲で入力してください。',
  E010016: '次の記号（{0}）は入力できません。',
  E010017: '「{0}」を選択してください。',
  E011001: '「{0}」と「{1}」が異なっています。',
  E011002: 'ファイル数が{0}を超えているため、アップロードできません。',
  E011003: '「{0}」は{1}を満たしていません。',
  E011004: '{0}で予期せぬエラーが発生しました。',
  E011005: '{0}のアップロードは失敗です。',
  E011006: '期間は、開始年度≦終了年度となるように設定してください。',
  E011007: 'モニタリング対象となるKGIまたはKPIが設定されていないため、公開できません。',
  E011008: '「予約後」として登録されているため、入力できません。',
  E011009: '{0}にマッピングされていない科目があるためアップロードできません。',
  E011010: '人的資本情報の分析データとして利用されているため、変更できません。',
  E011011: '「{0}」には「{1}」以降の日付を入力してください。',
  E011012: '処理中に予期せぬエラーが発生しました。システム管理者にお問い合わせください。',
  E011013: '「{0}」には「{1}」以降の月を入力してください。',
  E011014: '有効期間内に同一の法人番号「{0}」が既に存在します。',
  E011015: '有効期間内に同一の会社名「{0}」が既に存在します。',
  E011016: '「{0}」は{1}桁の半角数字で入力してください',
  E011017: '最低1つの{0}が必要です。',
  E011018: '{0}の開始日は終了日以前である必要があります。',
  E011019: '先に{0}をクリックして選択してください。',
  E011020: '{0}の開始月は終了月以前である必要があります。',
  E011021: '条件式が正しくありません。（{0}）',
  E011022:
    '対象データ分類「{0}」では、マッピング設定で複数のファイル種別を使用できません。1つのファイル種別に統一してください。',
  E011023: 'ファイルの読み込みに失敗しました。ファイル形式・内容をご確認ください。',
  E011024: '年度内の日付を登録してください。',
  E10206_001: 'データ取得に失敗しました',
  E10206_002: 'マッピング設定の保存に失敗しました',
  E10206_003: '通信エラーが発生しました',
  E10206_004: '権限がありません',
  E10206_005: 'セッションが無効です',
  E10206_006: '検証バッチの起動に失敗しました',
  E10206_007: '検証結果の取得に失敗しました',
  E10206_008: 'データ更新中のため、検証を実行できません。',
  E10206_009:
    'ベースファイルが未登録のため、検証を実行できません。ファイル管理画面でベースファイルを登録してください。',
  E020001: '必須項目です。',
  E020002: '（,\\"）は入力できません。',
  E020003: '同じ組織コードが既に存在します',
  E020004: '未登録の「{0}」です。',
  E020005: '組合せ不一致',
  E020006: '組織名が存在しません',
  W010001: '上書きされます'
}

export default Object.freeze(message)
